import Alpine from 'alpinejs';
import 'flowbite';
import $ from 'jquery';
import DataTable from 'datatables.net';

import Swal from 'sweetalert2';
import Choices from 'choices.js';
import flatpickr from 'flatpickr';
import { Indonesian } from 'flatpickr/dist/l10n/id.js';

window.Alpine = Alpine;
window.Swal = Swal;
window.$ = $;
window.jQuery = $;

/*
|--------------------------------------------------------------------------
| Toast
|--------------------------------------------------------------------------
*/

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3500,
    timerProgressBar: true,
    showCloseButton: true,
    customClass: {
        popup: 'rounded-xl',
    },
});

window.VektorGO = {
    toast(message, icon = 'success') {
        return Toast.fire({
            icon,
            title: message,
        });
    },

    confirm(options = {}) {
        return Swal.fire({
            icon: options.icon || 'warning',
            title: options.title || 'Apakah Anda yakin?',
            text: options.text || 'Tindakan ini akan memproses data.',
            showCancelButton: true,
            confirmButtonText: options.confirmText || 'Ya, Lanjutkan',
            cancelButtonText: options.cancelText || 'Batal',
            reverseButtons: true,
            focusCancel: true,
            customClass: {
                popup: 'rounded-2xl',
                confirmButton:
                    'rounded-xl bg-brand-600 px-5 py-2.5 text-sm font-bold text-white',
                cancelButton:
                    'rounded-xl border border-slate-300 bg-white px-5 py-2.5 text-sm font-bold text-slate-700',
            },
            buttonsStyling: false,
        });
    },

    prompt(options = {}) {
        return Swal.fire({
            icon: options.icon || 'warning',
            title: options.title || 'Tambah catatan',
            text: options.text || 'Silakan lengkapi catatan sebelum melanjutkan.',
            input: options.input || 'textarea',
            inputPlaceholder: options.placeholder || 'Tulis catatan di sini...',
            inputValue: options.value || '',
            inputAttributes: {
                rows: 4,
            },
            showCancelButton: true,
            confirmButtonText: options.confirmText || 'Lanjutkan',
            cancelButtonText: options.cancelText || 'Batal',
            reverseButtons: true,
            focusCancel: true,
            inputValidator: options.required
                ? (value) => {
                    if (!String(value || '').trim()) {
                        return 'Catatan wajib diisi.';
                    }

                    return undefined;
                }
                : undefined,
            customClass: {
                popup: 'rounded-2xl',
                confirmButton:
                    'rounded-xl bg-brand-600 px-5 py-2.5 text-sm font-bold text-white',
                cancelButton:
                    'rounded-xl border border-slate-300 bg-white px-5 py-2.5 text-sm font-bold text-slate-700',
            },
            buttonsStyling: false,
        });
    },
};

/*
|--------------------------------------------------------------------------
| Flash message Laravel
|--------------------------------------------------------------------------
*/

function initializeFlashMessages() {
    const element = document.getElementById('flash-messages');

    if (!element) {
        return;
    }

    try {
        const messages = JSON.parse(element.textContent);

        if (messages.success) {
            window.VektorGO.toast(messages.success, 'success');
        }

        if (messages.error) {
            window.VektorGO.toast(messages.error, 'error');
        }

        if (messages.warning) {
            window.VektorGO.toast(messages.warning, 'warning');
        }

        if (messages.info) {
            window.VektorGO.toast(messages.info, 'info');
        }
    } catch (error) {
        console.error('Flash message tidak dapat dibaca.', error);
    }
}

/*
|--------------------------------------------------------------------------
| SweetAlert confirmation
|--------------------------------------------------------------------------
*/

function initializeConfirmationForms() {
    document.addEventListener('submit', async (event) => {
        const form = event.target.closest('form[data-confirm]');

        if (!form || form.dataset.confirmed === 'true') {
            return;
        }

        event.preventDefault();

        const result = await window.VektorGO.confirm({
            title: form.dataset.confirmTitle,
            text: form.dataset.confirmText,
            icon: form.dataset.confirmIcon,
            confirmText: form.dataset.confirmButton,
        });

        if (result.isConfirmed) {
            form.dataset.confirmed = 'true';
            form.submit();
        }
    });
}

/*
|--------------------------------------------------------------------------
| Choices.js
|--------------------------------------------------------------------------
*/

function initializeChoices() {
    document.querySelectorAll('[data-choices]').forEach((element) => {
        if (element.dataset.choicesInitialized === 'true') {
            return;
        }

        new Choices(element, {
            allowHTML: false,
            searchEnabled: element.dataset.search !== 'false',
            removeItemButton: element.multiple,
            shouldSort: false,
            itemSelectText: '',
            noResultsText: 'Data tidak ditemukan',
            noChoicesText: 'Tidak ada pilihan tersedia',
            searchPlaceholderValue: 'Cari pilihan...',
            placeholder: true,
            placeholderValue: element.dataset.placeholder || 'Pilih salah satu',
        });

        element.dataset.choicesInitialized = 'true';
    });
}

/*
|--------------------------------------------------------------------------
| Flatpickr
|--------------------------------------------------------------------------
*/

function initializeFlatpickr() {
    document.querySelectorAll('[data-datepicker]').forEach((element) => {
        flatpickr(element, {
            locale: Indonesian,
            dateFormat: element.dataset.dateFormat || 'Y-m-d',
            altInput: true,
            altFormat: element.dataset.altFormat || 'j F Y',
            minDate: element.dataset.minDate || null,
            maxDate: element.dataset.maxDate || null,
            allowInput: true,
        });
    });

    document.querySelectorAll('[data-timepicker]').forEach((element) => {
        flatpickr(element, {
            locale: Indonesian,
            enableTime: true,
            noCalendar: true,
            dateFormat: 'H:i',
            time_24hr: true,
            minuteIncrement: parseInt(element.dataset.minuteIncrement || '15', 10),
            allowInput: true,
        });
    });
}

/*
|--------------------------------------------------------------------------
| Tutor verification action menu
|--------------------------------------------------------------------------
*/

function submitTutorVerificationDecision(url, decision, notes = '') {
    const form = document.createElement('form');
    const token = document.querySelector(
        'meta[name="csrf-token"]'
    )?.getAttribute('content') || '';

    form.method = 'POST';
    form.action = url;
    form.style.display = 'none';

    const tokenInput = document.createElement('input');
    tokenInput.type = 'hidden';
    tokenInput.name = '_token';
    tokenInput.value = token;

    const methodInput = document.createElement('input');
    methodInput.type = 'hidden';
    methodInput.name = '_method';
    methodInput.value = 'PATCH';

    const decisionInput = document.createElement('input');
    decisionInput.type = 'hidden';
    decisionInput.name = 'decision';
    decisionInput.value = decision;

    const notesInput = document.createElement('input');
    notesInput.type = 'hidden';
    notesInput.name = 'notes';
    notesInput.value = notes;

    form.append(tokenInput, methodInput, decisionInput, notesInput);

    document.body.appendChild(form);
    form.submit();
}

function initializeTutorVerificationActionMenus() {
    const closeMenus = () => {
        document
            .querySelectorAll('[data-tutor-action-menu]:not(.hidden)')
            .forEach((menu) => {
                menu.classList.add('hidden');
            });

        document
            .querySelectorAll('[data-tutor-action-toggle][aria-expanded="true"]')
            .forEach((button) => {
                button.setAttribute('aria-expanded', 'false');
        });
    };

    document.addEventListener('click', (event) => {
        const toggle = event.target.closest('[data-tutor-action-toggle]');
        const decisionButton = event.target.closest('[data-tutor-decision]');

        if (toggle) {
            const wrapper = toggle.closest('[data-tutor-action-wrap]');
            const menu = wrapper
                ? wrapper.querySelector('[data-tutor-action-menu]')
                : null;

            if (!menu) {
                return;
            }

            const isOpen = !menu.classList.contains('hidden');

            closeMenus();

            if (!isOpen) {
                menu.classList.remove('hidden');
                toggle.setAttribute('aria-expanded', 'true');
            }

            event.preventDefault();
            return;
        }

        if (decisionButton) {
            const wrapper = decisionButton.closest('[data-tutor-action-wrap]');
            const updateUrl = wrapper
                ? wrapper.dataset.tutorUpdateUrl
                : null;
            const decision = decisionButton.dataset.tutorDecision;

            if (!updateUrl || !decision) {
                return;
            }

            const approvalFlow = async () => {
                if (decision === 'approve') {
                    const result = await window.VektorGO.confirm({
                        title: 'Setujui tentor?',
                        text: 'Tentor yang disetujui dapat mulai mengelola jadwal dan menerima pesanan.',
                        confirmText: 'Ya, Setujui',
                    });

                    if (result.isConfirmed) {
                        submitTutorVerificationDecision(updateUrl, decision);
                    }

                    return;
                }

                const prompts = {
                    revision: {
                        title: 'Minta perbaikan?',
                        text: 'Tuliskan catatan agar tentor tahu apa yang perlu diperbaiki.',
                        confirmText: 'Ya, Kirim Catatan',
                        placeholder: 'Contoh: Foto profil kurang jelas atau CV belum lengkap.',
                    },
                    deactivate: {
                        title: 'Tolak tentor?',
                        text: 'Tuliskan alasan penolakan agar tercatat di sistem.',
                        confirmText: 'Ya, Tolak',
                        placeholder: 'Contoh: Data tidak sesuai atau dokumen tidak valid.',
                    },
                };

                const config = prompts[decision];

                if (!config) {
                    return;
                }

                const result = await window.VektorGO.prompt({
                    title: config.title,
                    text: config.text,
                    confirmText: config.confirmText,
                    placeholder: config.placeholder,
                    required: true,
                });

                if (result.isConfirmed) {
                    submitTutorVerificationDecision(
                        updateUrl,
                        decision,
                        String(result.value || '').trim()
                    );
                }
            };

            closeMenus();
            event.preventDefault();
            approvalFlow().catch((error) => {
                console.error('Gagal memproses aksi tentor.', error);
            });
            return;
        }

        if (event.target.closest('[data-tutor-action-menu]')) {
            return;
        }

        if (!event.target.closest('[data-tutor-action-wrap]')) {
            closeMenus();
        }
    });
}

/*
|--------------------------------------------------------------------------
| Tutor verification DataTables
|--------------------------------------------------------------------------
*/

function buildTutorVerificationCard(row) {
    return `
        <article class="rounded-2xl border border-slate-200 bg-white p-4 shadow-[0_1px_2px_rgba(15,23,42,0.03)]">
            <div class="flex items-start justify-between gap-3">
                <div class="min-w-0 flex-1">
                    ${row.tutor}
                </div>

                <div class="shrink-0">
                    ${row.action}
                </div>
            </div>

            <div class="mt-4 space-y-2">
                <p class="text-[10px] font-extrabold uppercase tracking-[0.18em] text-slate-400">
                    Informasi Mengajar
                </p>

                <div class="rounded-xl bg-slate-50 px-3 py-2.5">
                    ${row.teaching}
                </div>
            </div>

            <div class="mt-4 flex items-start justify-between gap-4 border-t border-slate-100 pt-4">
                <div>
                    <p class="text-[10px] font-extrabold uppercase tracking-[0.18em] text-slate-400">
                        Diajukan
                    </p>

                    <p class="mt-1 text-sm font-semibold text-slate-900">
                        ${row.submitted_at}
                    </p>
                </div>

                <a
                    href="${row.detail_url}"
                    class="inline-flex h-10 items-center justify-center rounded-xl border border-slate-200 bg-white px-4 text-sm font-bold text-slate-700 transition hover:border-brand-200 hover:bg-brand-50 hover:text-brand-700"
                >
                    Tinjau Pengajuan
                </a>
            </div>

            <div class="mt-3">
                ${row.status}
            </div>
        </article>
    `;
}

function getTutorVerificationPageNumbers(info, isMobile) {
    if (info.pages <= 1) {
        return [0];
    }

    if (isMobile) {
        const pages = [];

        if (info.page > 0) {
            pages.push(info.page - 1);
        }

        pages.push(info.page);

        if (info.page < info.pages - 1) {
            pages.push(info.page + 1);
        }

        return [...new Set(pages)];
    }

    const maxButtons = 5;
    const half = Math.floor(maxButtons / 2);
    let start = Math.max(0, info.page - half);
    let end = Math.min(info.pages - 1, start + maxButtons - 1);

    start = Math.max(0, end - maxButtons + 1);

    const pages = [];

    for (let index = start; index <= end; index += 1) {
        pages.push(index);
    }

    return pages;
}

function renderTutorVerificationFooter(table, footerElement) {
    if (!footerElement) {
        return;
    }

    const info = table.page.info();
    const isMobile = window.matchMedia('(max-width: 639px)').matches;
    const infoText = info.recordsDisplay > 0
        ? `${info.start + 1}–${info.end} dari ${info.recordsDisplay}${isMobile ? '' : ' data'}`
        : '0–0 dari 0 data';

    const infoElement = footerElement.querySelector(
        '[data-tutor-verification-info]'
    );

    if (infoElement) {
        infoElement.textContent = isMobile
            ? infoText
            : `Menampilkan ${infoText}`;
    }

    const paginationElement = footerElement.querySelector(
        '[data-tutor-verification-pagination]'
    );

    if (!paginationElement) {
        return;
    }

    const pages = getTutorVerificationPageNumbers(info, isMobile);
    const previousDisabled = info.page <= 0;
    const nextDisabled = info.page >= info.pages - 1;

    const buttonClass = [
        'inline-flex h-9 min-w-9 items-center justify-center rounded-xl border px-3 text-sm font-semibold transition',
    ].join(' ');

    const pageButton = (pageIndex, label, active = false, disabled = false) => {
        const stateClass = active
            ? 'border-brand-600 bg-brand-600 text-white'
            : 'border-slate-200 bg-white text-slate-700 hover:border-brand-200 hover:bg-brand-50 hover:text-brand-700';

        const disabledClass = disabled
            ? 'cursor-not-allowed border-slate-200 bg-slate-100 text-slate-400 hover:border-slate-200 hover:bg-slate-100 hover:text-slate-400'
            : stateClass;

        return `
            <button
                type="button"
                class="${buttonClass} ${disabled ? disabledClass : stateClass}"
                data-tutor-page="${pageIndex}"
                ${disabled ? 'disabled' : ''}
                ${active ? 'aria-current="page"' : ''}
            >
                ${label}
            </button>
        `;
    };

    let buttons = '';

    buttons += pageButton(
        Math.max(info.page - 1, 0),
        'Sebelumnya',
        false,
        previousDisabled
    );

    pages.forEach((pageIndex) => {
        buttons += pageButton(
            pageIndex,
            String(pageIndex + 1),
            pageIndex === info.page,
            false
        );
    });

    buttons += pageButton(
        Math.min(info.page + 1, info.pages - 1),
        'Berikutnya',
        false,
        nextDisabled
    );

    paginationElement.innerHTML = buttons;
}

function initializeTutorVerificationTable() {
    const tableElement = document.querySelector(
        '[data-tutor-verification-table]'
    );

    if (!tableElement) {
        return;
    }

    const searchInput = document.getElementById(
        'tutor-verification-search'
    );

    const searchButton = document.getElementById(
        'tutor-verification-search-button'
    );

    const statusFilter = document.getElementById(
        'tutor-verification-status'
    );

    const subjectFilter = document.getElementById(
        'tutor-verification-subject'
    );

    const methodFilter = document.getElementById(
        'tutor-verification-method'
    );

    const dateFromFilter = document.getElementById(
        'tutor-verification-date-from'
    );

    const dateToFilter = document.getElementById(
        'tutor-verification-date-to'
    );

    const resetButton = document.getElementById(
        'tutor-verification-reset'
    );

    const applyButton = document.getElementById(
        'tutor-verification-apply'
    );

    const cardsElement = document.querySelector(
        '[data-tutor-verification-cards]'
    );

    const footerElement = document.querySelector(
        '[data-tutor-verification-footer]'
    );

    const statusTabs = document.querySelectorAll(
        '[data-tutor-status-tab]'
    );

    const filterCountElement = document.querySelector(
        '[data-filter-count]'
    );

    let updateTutorVerificationFilterCount = () => {};
    let updateTutorVerificationStatusTabs = () => {};

    const table = new DataTable(tableElement, {
        processing: true,
        serverSide: true,
        searching: false,
        lengthChange: false,
        autoWidth: false,
        pageLength: 10,
        order: [],

        ajax: {
            url: tableElement.dataset.url,

            data(data) {
                data.keyword = searchInput
                    ? searchInput.value.trim()
                    : '';

                data.status = statusFilter
                    ? statusFilter.value
                    : '';

                data.subject = subjectFilter
                    ? subjectFilter.value
                    : '';

                data.method = methodFilter
                    ? methodFilter.value
                    : '';

                data.date_from = dateFromFilter
                    ? dateFromFilter.value
                    : '';

                data.date_to = dateToFilter
                    ? dateToFilter.value
                    : '';
            },
        },

        columns: [
            {
                data: 'tutor',
                name: 'tutor',
                orderable: false,
            },
            {
                data: 'teaching',
                name: 'teaching',
                orderable: false,
            },
            {
                data: 'submitted_at',
                name: 'tutor_profiles.submitted_at',
                orderable: false,
            },
            {
                data: 'status',
                name: 'users.tutor_status',
                orderable: false,
            },
            {
                data: 'action',
                name: 'action',
                orderable: false,
                width: '80px',
                className: 'text-center whitespace-nowrap',
            },
        ],

        dom: 'rt',

        drawCallback() {
            const rows = this.api().rows({ page: 'current' }).data().toArray();

            if (cardsElement) {
                cardsElement.innerHTML = rows.length
                    ? rows.map(buildTutorVerificationCard).join('')
                    : `
                        <div class="rounded-2xl border border-dashed border-slate-200 bg-white p-6 text-center">
                            <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-slate-100 text-slate-400">
                                <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path d="M6 4h12v16H6z"/>
                                    <path d="M9 8h6"/>
                                    <path d="M9 12h6"/>
                                </svg>
                            </div>

                            <h3 class="mt-4 text-sm font-bold text-slate-900">
                                Tidak ada pengajuan ditemukan
                            </h3>

                            <p class="mt-2 text-sm leading-6 text-slate-500">
                                Coba ubah kata pencarian atau filter yang digunakan.
                            </p>

                            <button
                                type="button"
                                class="vg-btn-secondary mx-auto mt-4"
                                data-tutor-reset-empty
                            >
                                Reset Filter
                            </button>
                        </div>
                    `;
            }

            renderTutorVerificationFooter(this.api(), footerElement);
            updateTutorVerificationStatusTabs();
            updateTutorVerificationFilterCount();
        },

        language: {
            processing: 'Memuat data...',
            emptyTable: 'Belum ada data tentor.',
            zeroRecords: 'Data tentor tidak ditemukan.',
            info: 'Menampilkan _START_–_END_ dari _TOTAL_ data',
            infoEmpty: 'Tidak ada data',
            paginate: {
                previous: 'Sebelumnya',
                next: 'Berikutnya',
            },
        },
    });

    updateTutorVerificationFilterCount = () => {
        if (!filterCountElement) {
            return;
        }

        const count = [
            searchInput && searchInput.value.trim() !== '',
            statusFilter && statusFilter.value !== '',
            subjectFilter && subjectFilter.value !== '',
            methodFilter && methodFilter.value !== '',
            dateFromFilter && dateFromFilter.value !== '',
            dateToFilter && dateToFilter.value !== '',
        ].filter(Boolean).length;

        filterCountElement.textContent = String(count);
        filterCountElement.classList.toggle('hidden', count === 0);
    };

    updateTutorVerificationStatusTabs = () => {
        const activeStatus = statusFilter ? statusFilter.value : '';

        statusTabs.forEach((tab) => {
            const tabStatus = tab.dataset.statusValue || '';
            const active = tabStatus === activeStatus;

            tab.classList.toggle('border-brand-500', active);
            tab.classList.toggle('bg-brand-50', active);
            tab.classList.toggle('text-brand-700', active);
            tab.classList.toggle('border-slate-200', !active);
            tab.classList.toggle('bg-white', !active);
            tab.classList.toggle('text-slate-600', !active);
            tab.classList.toggle('shadow-sm', active);

            const badge = tab.querySelector('[data-tab-count]');

            if (badge) {
                badge.classList.toggle('bg-brand-100', active);
                badge.classList.toggle('text-brand-700', active);
                badge.classList.toggle('bg-slate-100', !active);
                badge.classList.toggle('text-slate-500', !active);
            }
        });
    };

    const reloadTable = () => {
        table.ajax.reload();
    };

    const applyFilters = () => {
        reloadTable();
    };

    if (searchButton) {
        searchButton.addEventListener('click', applyFilters);
    }

    if (searchInput) {
        searchInput.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
                event.preventDefault();
                applyFilters();
            }
        });

        searchInput.addEventListener('input', updateTutorVerificationFilterCount);
    }

    if (statusFilter) {
        statusFilter.addEventListener('change', () => {
            updateTutorVerificationStatusTabs();
            updateTutorVerificationFilterCount();
        });
    }

    if (subjectFilter) {
        subjectFilter.addEventListener('change', updateTutorVerificationFilterCount);
    }

    if (methodFilter) {
        methodFilter.addEventListener('change', updateTutorVerificationFilterCount);
    }

    if (dateFromFilter) {
        dateFromFilter.addEventListener('change', updateTutorVerificationFilterCount);
    }

    if (dateToFilter) {
        dateToFilter.addEventListener('change', updateTutorVerificationFilterCount);
    }

    if (resetButton) {
        resetButton.addEventListener('click', () => {
            if (searchInput) {
                searchInput.value = '';
            }

            if (statusFilter) {
                statusFilter.value = '';
            }

            if (subjectFilter) {
                subjectFilter.value = '';
            }

            if (methodFilter) {
                methodFilter.value = '';
            }

            if (dateFromFilter) {
                dateFromFilter.value = '';
            }

            if (dateToFilter) {
                dateToFilter.value = '';
            }

            updateTutorVerificationStatusTabs();
            updateTutorVerificationFilterCount();

            reloadTable();
        });
    }

    if (applyButton) {
        applyButton.addEventListener('click', () => {
            updateTutorVerificationStatusTabs();
            updateTutorVerificationFilterCount();
            reloadTable();
            if (filterCountElement) {
                filterCountElement.classList.remove('hidden');
            }
        });
    }

    if (footerElement) {
        footerElement.addEventListener('click', (event) => {
            const pageButton = event.target.closest('[data-tutor-page]');

            if (!pageButton || pageButton.disabled) {
                return;
            }

            const pageIndex = Number(pageButton.dataset.tutorPage);

            if (Number.isNaN(pageIndex)) {
                return;
            }

            table.page(pageIndex).draw('page');
        });
    }

    statusTabs.forEach((tab) => {
        tab.addEventListener('click', () => {
            if (statusFilter) {
                statusFilter.value = tab.dataset.statusValue || '';
            }

            updateTutorVerificationStatusTabs();
            updateTutorVerificationFilterCount();
            reloadTable();
        });
    });

    document.addEventListener('click', (event) => {
        const emptyReset = event.target.closest('[data-tutor-reset-empty]');

        if (emptyReset) {
            if (resetButton) {
                resetButton.click();
            }
        }
    });

    updateTutorVerificationStatusTabs();
    updateTutorVerificationFilterCount();

    window.addEventListener('resize', () => {
        table.columns.adjust();
        renderTutorVerificationFooter(table, footerElement);
    });
}

function initializeMasterDataTables() {
    const configs = {
        subjects: {
            columns: [
                {
                    data: 'subject',
                    name: 'name',
                },
                {
                    data: 'sort_order',
                    name: 'sort_order',
                },
                {
                    data: 'status',
                    name: 'is_active',
                    orderable: false,
                },
                {
                    data: 'created_at',
                    name: 'created_at',
                    render(value) {
                        if (!value) {
                            return '-';
                        }

                        return new Intl.DateTimeFormat('id-ID', {
                            dateStyle: 'medium',
                        }).format(new Date(value));
                    },
                },
                {
                    data: 'action',
                    name: 'action',
                    orderable: false,
                    searchable: false,
                    className: 'text-right',
                },
            ],
        },
        durations: {
            columns: [
                {
                    data: 'duration',
                    name: 'name',
                },
                {
                    data: 'minutes',
                    name: 'minutes',
                },
                {
                    data: 'sort_order',
                    name: 'sort_order',
                },
                {
                    data: 'status',
                    name: 'is_active',
                    orderable: false,
                },
                {
                    data: 'action',
                    name: 'action',
                    orderable: false,
                    searchable: false,
                    className: 'text-right',
                },
            ],
        },
        'payment-accounts': {
            columns: [
                {
                    data: 'account',
                    name: 'bank_name',
                },
                {
                    data: 'sort_order',
                    name: 'sort_order',
                },
                {
                    data: 'status',
                    name: 'is_active',
                    orderable: false,
                },
                {
                    data: 'created_at',
                    name: 'created_at',
                    render(value) {
                        if (!value) {
                            return '-';
                        }

                        return new Intl.DateTimeFormat('id-ID', {
                            dateStyle: 'medium',
                        }).format(new Date(value));
                    },
                },
                {
                    data: 'action',
                    name: 'action',
                    orderable: false,
                    searchable: false,
                    className: 'text-right',
                },
            ],
        },
        payments: {
            columns: [
                {
                    data: 'payment',
                    name: 'payment_number',
                    orderable: false,
                },
                {
                    data: 'booking',
                    name: 'booking.booking_number',
                    orderable: false,
                },
                {
                    data: 'amount',
                    name: 'amount',
                    orderable: false,
                },
                {
                    data: 'submitted_at',
                    name: 'latestSubmission.submitted_at',
                    orderable: false,
                },
                {
                    data: 'status',
                    name: 'status',
                    orderable: false,
                },
                {
                    data: 'action',
                    name: 'action',
                    orderable: false,
                    searchable: false,
                    className: 'text-center',
                },
            ],
        },
    };

    document.querySelectorAll('[data-master-table]').forEach((tableElement) => {
        const config = configs[tableElement.dataset.type];

        if (!config) {
            return;
        }

        const searchInput = document.getElementById(tableElement.dataset.searchInput || '');
        const searchButton = document.getElementById(tableElement.dataset.searchButton || '');
        const statusFilter = document.getElementById(tableElement.dataset.statusFilter || '');
        const resetButton = document.getElementById(tableElement.dataset.resetButton || '');

        const table = new DataTable(tableElement, {
            processing: true,
            serverSide: true,
            searching: false,
            lengthChange: false,
            pageLength: 10,
            order: [],
            ajax: {
                url: tableElement.dataset.url,
                data(data) {
                    data.keyword = searchInput ? searchInput.value.trim() : '';
                    data.status = statusFilter ? statusFilter.value : '';
                },
            },
            columns: config.columns,
            dom: 'rt<"vg-table-footer"ip>',
            language: {
                processing: 'Memuat data...',
                emptyTable: 'Belum ada data.',
                zeroRecords: 'Data tidak ditemukan.',
                info: 'Menampilkan _START_–_END_ dari _TOTAL_ data',
                infoEmpty: 'Tidak ada data',
                paginate: {
                    previous: 'Sebelumnya',
                    next: 'Berikutnya',
                },
            },
        });

        const reload = () => {
            table.ajax.reload();
        };

        if (searchButton) {
            searchButton.addEventListener('click', reload);
        }

        if (searchInput) {
            searchInput.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    event.preventDefault();
                    reload();
                }
            });
        }

        if (statusFilter) {
            statusFilter.addEventListener('change', reload);
        }

        if (resetButton) {
            resetButton.addEventListener('click', () => {
                if (searchInput) {
                    searchInput.value = '';
                }

                if (statusFilter) {
                    statusFilter.value = '';
                }

                reload();
            });
        }
    });
}

function initializeMasterDataActions() {
    document.addEventListener('click', (event) => {
        const subjectButton = event.target.closest('[data-open-subject-modal]');

        if (subjectButton) {
            window.dispatchEvent(
                new CustomEvent('open-subject-modal', {
                    detail: JSON.parse(subjectButton.dataset.record),
                })
            );

            return;
        }

        const durationButton = event.target.closest('[data-open-duration-modal]');

        if (durationButton) {
            window.dispatchEvent(
                new CustomEvent('open-duration-modal', {
                    detail: JSON.parse(durationButton.dataset.record),
                })
            );

            return;
        }

        const paymentAccountButton = event.target.closest('[data-open-payment-account-modal]');

        if (paymentAccountButton) {
            window.dispatchEvent(
                new CustomEvent('open-payment-account-modal', {
                    detail: JSON.parse(paymentAccountButton.dataset.record),
                })
            );
        }
    });
}

function initializeTutorTeachingSetupActions() {
    document.addEventListener('click', (event) => {
        const rateButton = event.target.closest('[data-open-tutor-rate]');

        if (rateButton) {
            window.dispatchEvent(
                new CustomEvent('open-tutor-rate-modal', {
                    detail: JSON.parse(rateButton.dataset.record),
                })
            );

            return;
        }

        const scheduleButton = event.target.closest('[data-open-tutor-schedule]');

        if (scheduleButton) {
            window.dispatchEvent(
                new CustomEvent('open-tutor-schedule-modal', {
                    detail: JSON.parse(scheduleButton.dataset.record),
                })
            );
        }
    });
}

Alpine.data('tutorVerificationDecisionForm', (config = {}) => ({
    decision: config.initialDecision || '',
    notes: config.initialNotes || '',
    isSubmitting: false,
    options: Array.isArray(config.options) ? config.options : [],
    tutorName: config.tutorName || 'tentor',

    get selectedOption() {
        return (
            this.options.find((option) => option.value === this.decision) ||
            null
        );
    },

    get requiresNotes() {
        return ['revision', 'deactivate'].includes(this.decision);
    },

    get notesFieldId() {
        return 'decision-notes';
    },

    get submitLabel() {
        return this.selectedOption?.submitLabel || 'Simpan Keputusan';
    },

    get summaryText() {
        return this.selectedOption?.summaryText || '';
    },

    get notesLabel() {
        return this.selectedOption?.notesLabel || 'Catatan';
    },

    get notesPlaceholder() {
        return (
            this.selectedOption?.notesPlaceholder ||
            'Tulis catatan di sini...'
        );
    },

    get confirmTitle() {
        return this.selectedOption?.confirmTitle || 'Konfirmasi keputusan';
    },

    get confirmText() {
        const text = this.selectedOption?.confirmText || '';

        return text.replace(/\{\{name\}\}/g, this.tutorName);
    },

    get confirmButton() {
        return this.selectedOption?.confirmButton || this.submitLabel;
    },

    get canSubmit() {
        if (!this.decision) {
            return false;
        }

        if (this.requiresNotes) {
            return this.notes.trim().length > 0;
        }

        return true;
    },

    submitButtonClass() {
        if (!this.selectedOption) {
            return 'bg-slate-200 text-slate-400 hover:bg-slate-200';
        }

        switch (this.selectedOption?.tone) {
            case 'warning':
                return 'bg-amber-600 text-white hover:bg-amber-700';

            case 'danger':
                return 'bg-red-600 text-white hover:bg-red-700';

            default:
                return 'bg-brand-600 text-white hover:bg-brand-700';
        }
    },

    optionCardClass(value, tone) {
        const active = this.decision === value;

        const toneClasses = {
            brand: active
                ? 'border-brand-600 bg-brand-50 ring-1 ring-brand-600/15'
                : 'border-slate-200 bg-white hover:border-brand-200 hover:bg-brand-50/40',
            warning: active
                ? 'border-amber-500 bg-amber-50 ring-1 ring-amber-500/15'
                : 'border-slate-200 bg-white hover:border-amber-200 hover:bg-amber-50/40',
            danger: active
                ? 'border-red-500 bg-red-50 ring-1 ring-red-500/15'
                : 'border-slate-200 bg-white hover:border-red-200 hover:bg-red-50/40',
        };

        return toneClasses[tone] || toneClasses.brand;
    },

    radioRingClass(value, tone) {
        const active = this.decision === value;

        const toneClasses = {
            brand: active
                ? 'border-brand-600 bg-brand-600 text-white'
                : 'border-slate-300 bg-white text-transparent',
            warning: active
                ? 'border-amber-600 bg-amber-500 text-white'
                : 'border-slate-300 bg-white text-transparent',
            danger: active
                ? 'border-red-600 bg-red-500 text-white'
                : 'border-slate-300 bg-white text-transparent',
        };

        return toneClasses[tone] || toneClasses.brand;
    },

    radioDotClass(value, tone) {
        const active = this.decision === value;

        const toneClasses = {
            brand: active ? 'bg-white' : 'bg-transparent',
            warning: active ? 'bg-white' : 'bg-transparent',
            danger: active ? 'bg-white' : 'bg-transparent',
        };

        return toneClasses[tone] || toneClasses.brand;
    },

    async handleSubmit() {
        if (!this.canSubmit || this.isSubmitting || !this.selectedOption) {
            return;
        }

        const result = await window.VektorGO.confirm({
            title: this.confirmTitle,
            text: this.confirmText,
            confirmText: this.confirmButton,
            icon: this.selectedOption.confirmIcon || 'warning',
        });

        if (!result.isConfirmed) {
            return;
        }

        this.isSubmitting = true;
        this.$nextTick(() => {
            this.$refs.form.submit();
        });
    },
}));

/*
|--------------------------------------------------------------------------
| Jalankan komponen
|--------------------------------------------------------------------------
*/

window.bookingForm = function bookingForm(options, initial = {}) {
    return {
        options,
        selectedRate: String(initial.rate || ''),
        selectedSchedule: String(initial.schedule || ''),
        selectedDate: String(initial.date || ''),

        get currentRate() {
            return this.options.rates[this.selectedRate] || null;
        },

        get availableSchedules() {
            if (!this.currentRate) {
                return [];
            }

            return Object.values(this.options.schedules).filter((schedule) => {
                return String(schedule.duration_id) === String(this.currentRate.duration_id);
            });
        },

        get currentSchedule() {
            return this.options.schedules[this.selectedSchedule] || null;
        },

        get availableDates() {
            if (!this.currentSchedule) {
                return [];
            }

            return this.currentSchedule.dates || [];
        },

        rateChanged() {
            const scheduleStillValid = this.availableSchedules.some((schedule) => {
                return String(schedule.id) === String(this.selectedSchedule);
            });

            if (!scheduleStillValid) {
                this.selectedSchedule = '';
                this.selectedDate = '';
            }
        },

        scheduleChanged() {
            const dateStillValid = this.availableDates.some((date) => {
                return date.value === this.selectedDate;
            });

            if (!dateStillValid) {
                this.selectedDate = '';
            }
        },

        formatCurrency(value) {
            return new Intl.NumberFormat('id-ID', {
                style: 'currency',
                currency: 'IDR',
                maximumFractionDigits: 0,
            }).format(Number(value || 0));
        },
    };
};

document.addEventListener('DOMContentLoaded', () => {
    initializeFlashMessages();
    initializeConfirmationForms();
    initializeChoices();
    initializeFlatpickr();
    initializeTutorVerificationActionMenus();
    initializeTutorVerificationTable();
    initializeMasterDataTables();
    initializeMasterDataActions();
    initializeTutorTeachingSetupActions();
});

Alpine.start();
